// @core/api/endpoints/calendar/get_calendar.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CalendarResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Get calendar
 * Retrieves calendar details including settings, owner, and member count.
 */
export async function GetCalendar(
  calendar_id: string,
  options?: RequestOptions
): Promise<CalendarResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendars/:calendar_id`;
  requestPath = requestPath.replace(':calendar_id', encodeURIComponent(calendar_id));
  const requestOptions = options;
  return client.get<CalendarResponse>(requestPath, { ...requestOptions });
}
